var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndeterminate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.625H5.25C4.76875 16.625 4.375 16.2312 4.375 15.75V5.25C4.375 4.76875 4.76875 4.375 5.25 4.375H15.75C16.2312 4.375 16.625 4.76875 16.625 5.25V15.75C16.625 16.2312 16.2312 16.625 15.75 16.625ZM16.625 2.625H4.375C3.4125 2.625 2.625 3.4125 2.625 4.375V16.625C2.625 17.5875 3.4125 18.375 4.375 18.375H16.625C17.5875 18.375 18.375 17.5875 18.375 16.625V4.375C18.375 3.4125 17.5875 2.625 16.625 2.625Z",
    fill: "#DEFFFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10C7 9.44772 7.44772 9 8 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H8C7.44772 11 7 10.5523 7 10Z",
    fill: "#00FFB0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeterminate);
export default __webpack_public_path__ + "static/media/indeterminate.f2aab8fd5fc7f686770a9e3288522557.svg";
export { ForwardRef as ReactComponent };